module.exports = __webpack_public_path__ + "static/media/mercedes_02.535b2f52.png";